export const documentsConstants = {
  DOCUMENTS_REQUEST: 'DOCUMENTS_REQUEST',
  DOCUMENTS_SUCCESS: 'DOCUMENTS_SUCCESS',
  DOCUMENTS_FAILURE: 'DOCUMENTS_FAILURE',
  DOCUMENTS_RESET: 'DOCUMENTS_RESET',

  DOCUMENTS_UPLOAD_REQUEST: 'DOCUMENTS_UPLOAD_REQUEST',
  DOCUMENTS_UPLOAD_SUCCESS: 'DOCUMENTS_UPLOAD_SUCCESS',
  DOCUMENTS_UPLOAD_FAILURE: 'DOCUMENTS_UPLOAD_FAILURE',

  DOCUMENTS_EVIDENCE_REQUEST: 'DOCUMENTS_EVIDENCE_REQUEST',
  DOCUMENTS_EVIDENCE_SUCCESS: 'DOCUMENTS_EVIDENCE_SUCCESS',
  DOCUMENTS_EVIDENCE_FAILURE: 'DOCUMENTS_EVIDENCE_FAILURE',

  UPLOAD_SECTION_REQUEST: 'UPLOAD_SECTION_REQUEST',
  UPLOAD_SECTION_SUCCESS: 'UPLOAD_SECTION_SUCCESS',
  UPLOAD_SECTION_FAILURE: 'UPLOAD_SECTION_FAILURE',
  UPLOAD_SECTION_RESET: 'UPLOAD_SECTION_RESET',

  UPLOAD_DOCUMENTS_REQUEST: 'UPLOAD_DOCUMENTS_REQUEST',
  UPLOAD_DOCUMENTS_SUCCESS: 'UPLOAD_DOCUMENTS_SUCCESS',
  UPLOAD_DOCUMENTS_FAILURE: 'UPLOAD_DOCUMENTS_FAILURE',

  GET_OCRDATA_REQUEST: 'GET_OCRDATA_REQUEST',
  GET_OCRDATA_SUCCESS: 'GET_OCRDATA_SUCCESS',
  GET_OCRDATA_FAILURE: 'GET_OCRDATA_FAILURE',

  GET_DOCUMENTS_REQUEST: 'GET_DOCUMENTS_REQUEST',
  GET_DOCUMENTS_SUCCESS: 'GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_FAILURE: 'GET_DOCUMENTS_FAILURE',

  AUTOGRAPH_SIGN_REQUEST: 'AUTOGRAPH_SIGN_REQUEST',
  AUTOGRAPH_SIGN_SUCCESS: 'AUTOGRAPH_SIGN_SUCCESS',
  AUTOGRAPH_SIGN_FAILURE: 'AUTOGRAPH_SIGN_FAILURE',
  AUTOGRAPH_SIGN_RESET: 'AUTOGRAPH_SIGN_RESET',

  REGISTER_DATA_REQUEST: 'REGISTER_DATA_REQUEST',
  REGISTER_DATA_SUCCESS: 'REGISTER_DATA_SUCCESS',
  REGISTER_DATA_FAILURE: 'REGISTER_DATA_FAILURE',

  FACIAL_COMPARISON_REQUEST: 'FACIAL_COMPARISON_REQUEST',
  FACIAL_COMPARISON_SUCCESS: 'FACIAL_COMPARISON_SUCCESS',
  FACIAL_COMPARISON_FAILURE: 'FACIAL_COMPARISON_FAILURE',
  FACIAL_COMPARISON_RESET: 'FACIAL_COMPARISON_RESET',

  REGISTERTWO_DATA_REQUEST: 'REGISTERTWO_DATA_REQUEST',
  REGISTERTWO_DATA_SUCCESS: 'REGISTERTWO_DATA_SUCCESS',
  REGISTERTWO_DATA_FAILURE: 'REGISTERTWO_DATA_FAILURE',

  VALIDATEDENTITY_DATA_REQUEST: 'VALIDATEDENTITY_DATA_REQUEST',
  VALIDATEDENTITY_DATA_SUCCESS: 'VALIDATEDENTITY_DATA_SUCCESS',
  VALIDATEDENTITY_DATA_FAILURE: 'VALIDATEDENTITY_DATA_FAILURE',

  GETVALIDATEDENTITY_DATA_REQUEST: 'GETVALIDATEDENTITY_DATA_REQUEST',
  GETVALIDATEDENTITY_DATA_SUCCESS: 'GETVALIDATEDENTITY_DATA_SUCCESS',
  GETVALIDATEDENTITY_DATA_FAILURE: 'GETVALIDATEDENTITY_DATA_FAILURE',

  DOCUMENTS_ASYNC_REQUEST: 'DOCUMENTS_ASYNC_REQUEST',
  DOCUMENTS_ASYNC_SUCCESS: 'DOCUMENTS_ASYNC_SUCCESS',
  DOCUMENTS_ASYNC_FAILURE: 'DOCUMENTS_ASYNC_FAILURE',

  UPLOAD_DOCUMENT_SECTION_CONTENT_REQUEST: 'UPLOAD_DOCUMENT_SECTION_CONTENT_REQUEST',
  UPLOAD_DOCUMENT_SECTION_CONTENT_SUCCESS: 'UPLOAD_DOCUMENT_SECTION_CONTENT_SUCCESS',
  UPLOAD_DOCUMENT_SECTION_CONTENT_FAILURE: 'UPLOAD_DOCUMENT_SECTION_CONTENT_FAILURE',

  UPLOAD_MINUTIAE_REQUEST: 'UPLOAD_MINUTIAE_REQUEST',
  UPLOAD_MINUTIAE_SUCCESS: 'UPLOAD_MINUTIAE_SUCCESS',
  UPLOAD_MINUTIAE_FAILURE: 'UPLOAD_MINUTIAE_FAILURE',

  UPLOAD_VIDEO_EVIDENCE_JSON_REQUEST: 'UPLOAD_VIDEO_EVIDENCE_JSON_REQUEST',
  UPLOAD_VIDEO_EVIDENCE_JSON_SUCCESS: 'UPLOAD_VIDEO_EVIDENCE_JSON_SUCCESS',
  UPLOAD_VIDEO_EVIDENCE_JSON_FAILURE: 'UPLOAD_VIDEO_EVIDENCE_JSON_FAILURE',

  DIGITAL_SING_SAT_DOC_REQUEST: 'DIGITAL_SING_SAT_DOC_REQUEST',
  DIGITAL_SING_SAT_DOC_SUCCESS: 'DIGITAL_SING_SAT_DOC_SUCCESS',
  DIGITAL_SING_SAT_DOC_FAILURE: 'DIGITAL_SING_SAT_DOC_FAILURE',

  CARGADOC_WITH_SECTION_REQUEST: 'CARGADOC_WITH_SECTION_REQUEST',
  CARGADOC_WITH_SECTION_SUCCESS: 'CARGADOC_WITH_SECTION_SUCCESS',
  CARGADOC_WITH_SECTION_FAILURE: 'CARGADOC_WITH_SECTION_FAILURE',

}
